import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import CloudflareImage from '../components/ui/cloudflare-image';

const PageContainer = styled.div`
  width: 100%;
  padding: 0;
`;

const NavbarSpacer = styled.div`
  height: 120px;
  
  @media (min-width: 768px) {
    height: 140px;
  }
  
  @media (min-width: 1024px) {
    height: 160px;
  }
`;

const ContentContainer = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
  
  @media (min-width: 1536px) {
    max-width: 1600px;
  }
  
  @media (min-width: 768px) {
    padding: 0 5%;
  }
  
  @media (min-width: 1024px) {
    padding: 0 10px;
  }
`;

const TabsWrapper = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  max-width: 100%;
  
  @media (min-width: 1024px) {
    padding-bottom: 2rem;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
  
  @media (min-width: 1024px) {
    gap: 1rem;
  }
`;

const Tab = styled(Link)`
  font-weight: 300;
  background-color: ${props => props.active ? '#7a7a7a' : '#e9e9e9'};
  padding: 0.5rem 1.25rem;
  min-width: 150px;
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  text-align: center;
  text-decoration: none;
  color: ${props => props.active ? '#fff' : '#000'};
`;

const ComingSoonContainer = styled.div`
  background-color: #e9e9e9;
  border-radius: 0.75rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const ComingSoonImage = styled(CloudflareImage)`
  max-width: 100%;
  height: auto;
`;

const ComingSoonPage = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  const tabs = [
    { id: 'market', name: 'MARKET', path: '/market' },
    { id: 'leaderboard', name: 'LEADERBOARD', path: '/leaderboard' },
    { id: 'auctions', name: 'TMZ AUCTIONS', path: '/auctions' },
    { id: 'spotted', name: 'SPOTTED', path: '/spotted' },
    { id: 'irl', name: 'IRL', path: '/irl' },
    { id: 'recruit', name: 'RECRUIT', path: '/recruit' },
  ];
  
  // Extract the current tab ID from the path
  const currentTabId = currentPath.split('/')[1];

  return (
    <PageContainer>
      <NavbarSpacer />
      <ContentContainer>
        <TabsWrapper>
          <TabsContainer>
            {tabs.map(tab => (
              <Tab 
                key={tab.id} 
                to={tab.path} 
                active={tab.id === currentTabId ? 1 : 0}
              >
                {tab.name}
              </Tab>
            ))}
          </TabsContainer>
        </TabsWrapper>
        
        <ComingSoonContainer>
          <ComingSoonImage src="/images/coming_soon.webp" alt="Coming Soon" />
        </ComingSoonContainer>
      </ContentContainer>
    </PageContainer>
  );
};

export default ComingSoonPage; 